import React from 'react'

export const shipmentPopoverContent = 'Processed date is when your order is moved into the fulfillment stage, where it is picked,'
  + 'packaged and prepared for shipment. See Dashboard FAQs for more information.'
